import {mergeWith} from 'lodash'

export const deepMergeNoArray = (target, source) => {
  return mergeWith({}, target, source, (objValue, srcValue) => {
    // whenever both sides are arrays, throw away the original and use the incoming
    if (Array.isArray(objValue) && Array.isArray(srcValue)) {
      return srcValue
    }
    // otherwise fall back to default merge behavior (deep merge objects/primitives)
    return undefined
  })
}
